import type { MessageKey } from '@bitwize/i18n-messages';

/**
 * ─────────────────────────────────────────────────────────────────────────
 *  EDIT HERE. These are Bitwize's own published claims about Bitwize.
 * ─────────────────────────────────────────────────────────────────────────
 *
 * Every figure below is a marketing claim the company makes about itself
 * (Bitwize logo approval mock, 2026-08), not a number the site measured or
 * read back from the database — which is exactly why they live in one
 * marked file instead of being scattered through JSX. Whoever owns the
 * claim edits this file; nothing else needs touching.
 *
 * This is deliberately *not* the same thing as the inventory counts the
 * hero used to show (`stats.projects` from `+data.ts`), which are real
 * catalogue totals and must never be padded. If a figure here stops being
 * true, delete its entry — an empty list renders no row at all rather than
 * a stale boast.
 *
 * `value` is an authored string, not a number: "120+", "99.98%" and "12/wk"
 * carry a unit and a precision that a locale number formatter would either
 * mangle or silently change. They render `dir="ltr"` for that reason, the
 * same treatment every other technical token on the site gets (route
 * markers, the terminal session, version strings).
 */
export interface LandingMetric {
  value: string;
  labelKey: MessageKey;
}

/** The three tiles under the hero's call-to-action buttons. */
export const HERO_METRICS: readonly LandingMetric[] = [
  { value: '120+', labelKey: 'common.home.metricPlatforms' },
  { value: '99.98%', labelKey: 'common.home.metricUptime' },
  { value: '14 yrs', labelKey: 'common.home.metricPractice' },
];

/** The strip along the bottom of the hero's deploy-terminal card. */
export const TERMINAL_METRICS: readonly LandingMetric[] = [
  { value: '99.98%', labelKey: 'common.home.metricUptimeShort' },
  { value: '42ms', labelKey: 'common.home.metricLatency' },
  { value: '12/wk', labelKey: 'common.home.metricDeploys' },
];
